import { NgModule } from '@angular/core';

import { AuthProvider } from './providers/services/auth/auth.provider';
import { AuthService } from './services/auth.service';

import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { CarroComprasService } from '../view-model/services/carro-compras.service';
import { NotificacionCorreoService } from '../view-model/services/notificacion-correo.service';
import { ActEconomicasRubrosProvider } from './providers/services/act-economicas-rubros/act-economicas-rubros.provider';
import { AgendaProvider } from './providers/services/agenda/agenda.provider';
import { AnexoContratoProvider } from './providers/services/anexo-contrato/anexo-contrato.provider';
import { BancoProvider } from './providers/services/banco/banco.provider';
import { CartaPoderProvider } from './providers/services/carta-poder/carta-poder.provider';
import { ContactoProvider } from './providers/services/contacto/contacto.provider';
import { CuentaAbonoProvider } from './providers/services/cuenta-abono/cuenta-abono.provider';
import { CuotasProvider } from './providers/services/cuotas/cuotas.provider';
import { DatosComercioProvider } from './providers/services/datos-comercio/datos-comercio.provider';
import { DatosPersonalesProvider } from './providers/services/datos-personales/datos-personales.provider';
import { DatosSociosProvider } from './providers/services/datos-socios/datos-socios.provider';
import { DeclaracionJuradaProvider } from './providers/services/declaracion-jurada/declaracion-jurada.provider';
import { DocumentProvider } from './providers/services/document/document.provider';
import { Firmaprovider } from './providers/services/firma/firma.provider';
import { FlujosPaso2PJProvider } from './providers/services/flujos/flujos-paso-2-pj.provider';
import { FlujosPaso2Provider } from './providers/services/flujos/flujos-paso-2.provider';
import { FlujosPaso3Provider } from './providers/services/flujos/flujos-paso-3.provider';
import { InputErrorProvider } from './providers/services/input-error/input-errors.provider';
import { InstalacionDireccionProvider } from './providers/services/instalacion-direccion/instalacion-direccion.provider';
import { LocalStorageProvider } from './providers/services/localstorage/localstorage.provider';
import { NotificacionCorreoProvider } from './providers/services/notificacion-correo/notificacion-correo.provider';
import { ProductosProvider } from './providers/services/productos/productos.provider';
import { ProveedorProvider } from './providers/services/proveedor-servicios/proveeedor-servicios.provider';
import { ResumenProvider } from './providers/services/resumen/resumen.provider';
import { SiguientesPasosProvider } from './providers/services/siguientes-pasos/siguientes-pasos.provider';
import { TagManagerFactory } from './providers/services/tag-manager/tag-manager.factory';
import { UafProvider } from './providers/services/uaf/uaf.provider';
import { ValidacionEdicionProvider } from './providers/services/validacion-edicion/validacion-edicion.provider';
import { ActEconomicasRubrosService } from './services/act-economicas-rubros.service';
import { AgendaService } from './services/agenda.service';
import { AnexoContratoService } from './services/anexo-contrato.service';
import { BancoService } from './services/banco.service';
import { CartaPoderService } from './services/carta-poder.service';
import { ContactoService } from './services/contacto.service';
import { CuentaAbonoSubject } from './services/cuenta-abono-subject.service';
import { CuentaAbonoService } from './services/cuenta-abono.service';
import { CuotasService } from './services/cuotas.service';
import { DatosComercioService } from './services/datos-comercio.service';
import { DatosPersonalesService } from './services/datos-personales.service';
import { DatosSociosService } from './services/datos-socios.service';
import { DeclaracionJuradaService } from './services/declaracion-jurada.service';
import { DocumentService } from './services/document.service';
import { FirmaService } from './services/firma.service';
import { FlujosPaso2PJService } from './services/flujos-paso-2-pj.service';
import { FlujosPaso2Service } from './services/flujos-paso-2.service';
import { FlujosPaso3Service } from './services/flujos-paso-3.service';
import { InputErrorService } from './services/input-errors.service';
import { InstalacionDireccionService } from './services/instalacion-direccion.service';
import { LocalStorageService } from './services/localstorage.service';
import { ProductosService } from './services/productos.service';
import { ProveedorService } from './services/proveedor-servicios.service';
import { ResumenService } from './services/resumen.service';
import { SiguientesPasosService } from './services/siguientes-pasos.service';
import { TagManagerService } from './services/tag-manager.service';
import { UafService } from './services/uaf.service';
import { ValidacionEdicionService } from './services/validacion-edicion.service';

@NgModule({
    providers: [
        {
            provide: AuthService,
            useClass: AuthProvider
        },
        {
            provide: DatosPersonalesService,
            useClass: DatosPersonalesProvider
        },
        {
            provide: NotificacionCorreoService,
            useClass: NotificacionCorreoProvider
        },
        {
            provide: ContactoService,
            useClass: ContactoProvider
        },
        {
            provide: ValidacionEdicionService,
            useClass: ValidacionEdicionProvider
        },
        {
            provide: CuotasService,
            useClass: CuotasProvider
        },
        {
            provide: DeclaracionJuradaService,
            useClass: DeclaracionJuradaProvider
        },
        {
            provide: AnexoContratoService,
            useClass: AnexoContratoProvider
        },
        {
            provide: ProductosService,
            useClass: ProductosProvider
        },
        {
            provide: InstalacionDireccionService,
            useClass: InstalacionDireccionProvider
        },
        {
            provide: AgendaService,
            useClass: AgendaProvider
        },
        {
            provide: CuentaAbonoService,
            useClass: CuentaAbonoProvider
        },
        {
            provide: DatosComercioService,
            useClass: DatosComercioProvider
        },
        {
            provide: DocumentService,
            useClass: DocumentProvider
        },
        {
            provide: BancoService,
            useClass: BancoProvider
        },
        {
            provide: CartaPoderService,
            useClass: CartaPoderProvider
        },
        {
            provide: ActEconomicasRubrosService,
            useClass: ActEconomicasRubrosProvider
        },
        {
            provide: LocalStorageService,
            useClass: LocalStorageProvider
        },
        {
            provide: FlujosPaso2Service,
            useClass: FlujosPaso2Provider
        },
        {
            provide: FlujosPaso2PJService,
            useClass: FlujosPaso2PJProvider
        },
        {
            provide: FlujosPaso3Service,
            useClass: FlujosPaso3Provider
        },
        {
            provide: ResumenService,
            useClass: ResumenProvider
        },
        {
            provide: TagManagerService,
            useFactory: TagManagerFactory,
            deps:[LocalStorageService,CarroComprasService,GoogleTagManagerService]
            //useClass: TagManagerProvider
        },
        {
            provide: InputErrorService,
            useClass: InputErrorProvider
        },
        {
            provide: FirmaService,
            useClass: Firmaprovider
        },
        {
            provide: SiguientesPasosService,
            useClass: SiguientesPasosProvider
        },
        {
            provide: DatosSociosService,
            useClass: DatosSociosProvider

        },
        {
            provide: UafService,
            useClass: UafProvider
        },
        {
            provide: ProveedorService,
            useClass: ProveedorProvider
        },
        CuentaAbonoSubject
    ]
})
export class GlobalModule { }
